import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./Navbar.css";
import config from "../config";
import categories from "../data/categories"; // 👈 add this static JSON import

const Navbar = () => {
  const [navOpen, setNavOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [services, setServices] = useState([]);
  const menuRef = useRef(null);

  // Detect mobile screen
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 992;
      setIsMobile(mobile);
      if (!mobile) setOpenDropdown(null);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch services from API (with fallback)
  useEffect(() => {
    const fetchServices = async () => {
      try {
        console.log("API Base URL:", config.apiBaseURL);

        if (!config.apiBaseURL || config.apiBaseURL.includes("undefined")) {
          console.warn("⚠️ Invalid API URL, using local JSON instead");
          setServices(categories);
          return;
        }

        const response = await axios.get(`${config.apiBaseURL}/Categories/GetHierchy`);
        setServices(response.data || []);
      } catch (err) {
        console.error("Error fetching from API, falling back to local JSON:", err);
        setServices(categories); // 👈 fallback if API fails
      }
    };

    fetchServices();
  }, []);

  const toggleMobileMenu = () => {
    setNavOpen((prev) => !prev);
    setOpenDropdown(null);
  };

  const toggleDropdown = (menuName) => {
    if (isMobile) {
      setOpenDropdown((prev) => (prev === menuName ? null : menuName));
    }
  };

  const closeAllMenus = () => {
    setNavOpen(false);
    setOpenDropdown(null);
  };

  // Recursive service menu
  const renderServiceMenu = (items) => (
    <ul className="nav-dropdown">
      {items.map((item) => (
        <li key={item.categoryId || item.title}>
          <Link
            to={`/our-services?category=${item.categoryId || ""}`}
            onClick={closeAllMenus}
          >
            {item.categoryName || item.title}
          </Link>
          {item.children && item.children.length > 0 && renderServiceMenu(item.children)}
        </li>
      ))}
    </ul>
  );

  return (
    <header className="navbar" ref={menuRef}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeAllMenus}>
          <img
            src="/assets/img/sanjaylogo.png"
            alt="CA Sanjay P. & Associates"
            className="logo-img"
          />
        </Link>

        <nav className={`nav-links ${navOpen ? "active" : ""}`}>
          <ul>
            <li><Link to="/" onClick={closeAllMenus}>HOME</Link></li>

            <li
              className={`dropdown ${openDropdown === "company" ? "open" : ""}`}
              onClick={() => toggleDropdown("company")}
            >
              <button type="button">
                COMPANY <i className="bi bi-chevron-down"></i>
              </button>
              <ul className="nav-dropdown">
                <li><Link to="/aboutus" onClick={closeAllMenus}>ABOUT US</Link></li>
                <li><Link to="/our-expertise" onClick={closeAllMenus}>EXPERTISE</Link></li>
                <li><Link to="/our-philosphy" onClick={closeAllMenus}>PHILOSOPHY</Link></li>
                <li><Link to="/our-vision" onClick={closeAllMenus}>OUR VISION</Link></li>
                <li><Link to="/our-mission" onClick={closeAllMenus}>OUR MISSION</Link></li>
              </ul>
            </li>

            <li
              className={`dropdown ${openDropdown === "services" ? "open" : ""}`}
              onClick={() => toggleDropdown("services")}
            >
              <button type="button">
                SERVICES <i className="bi bi-chevron-down"></i>
              </button>
              {services.length > 0
                ? renderServiceMenu(services)
                : <ul className="nav-dropdown"><li>Loading...</li></ul>}
            </li>

            <li><Link to="/our-teams" onClick={closeAllMenus}>OUR TEAM</Link></li>
            <li><Link to="/contact" onClick={closeAllMenus}>CONTACT US</Link></li>
          </ul>
        </nav>

        <i
          className={`mobile-toggle bi ${navOpen ? "bi-x" : "bi-list"}`}
          onClick={toggleMobileMenu}
        ></i>
      </div>
    </header>
  );
};

export default Navbar;
